import AccountSection from '@/views/AccountSection.vue';
import DocumentationSection from '@/views/DocumentationSection.vue';

export default [
  {
    path: '',
    redirect: '/dashboard',
    name: 'index',
  },
  {
    path: '/account',
    name: 'account',
    component: AccountSection,
    meta: {
      breadcrumb: {
        linkName: 'account',
        linkText: 'Account',
      },
    },
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: DocumentationSection,
    meta: {
      breadcrumb: {
        linkName: 'documentation',
        linkText: 'Documentation',
      },
    },
  },
];
